import React from 'react';
import { Link } from 'react-router-dom';
import { getBookingUrl, trackBookCtaClick } from '../utils/gtag';
import './ServiceCard.css';

function ServiceCard({ service, onBookNow }) {
  // Each service category routes to its dedicated landing page
  // (/book/<slug>). Book.js then auto-opens the BookingModal with the
  // matching service preselected, so the end UX is one click → URL
  // changes → form opens. This gives Ads campaigns a unique landing
  // page per vehicle type for conversion tracking.
  const dedicatedUrl = service && service.category
    ? getBookingUrl(`service_card_${service.category}`, service.category)
    : null;

  const cardContent = (
    <>
      <div className="service-image">
        <img src={service.image} alt={service.title} />
      </div>
      <div className="service-content">
        <h3>{service.title}</h3>
        <p className="service-description">{service.description}</p>
        <div className="service-details">
          <span className="service-duration">{service.duration}</span>
          <span className="service-price">${service.price}</span>
        </div>
        <span className="book-now-btn" aria-hidden="true">BOOK NOW</span>
      </div>
    </>
  );

  if (dedicatedUrl) {
    return (
      <Link
        to={dedicatedUrl}
        className="service-card service-card-link"
        data-event="cta_booking_click"
        data-cta-location={`service_card_${service.category}`}
        onClick={() => trackBookCtaClick(`service_card_${service.category}`)}
        aria-label={`Book ${service.title}`}
      >
        {cardContent}
      </Link>
    );
  }

  // Fallback: services without a category fall back to the legacy
  // in-place modal flow.
  return (
    <div
      className="service-card"
      onClick={onBookNow}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onBookNow && onBookNow()}
    >
      {cardContent}
    </div>
  );
}

export default ServiceCard;
